import { EditModal } from "@/components/EditModal"
import { EditOutlined } from "@ant-design/icons"
import { useContext, useEffect, useMemo, useState } from "react"
import { ManualInput } from "../ManualInput"
import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import { numberFixTo } from "../utils"
import { ManualVal } from "@/types/common"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { isObject, isNumber } from "lodash";
import { Alignment, DivNumberInput } from "@/components/DivInput/DivNumberInput"

import classNames from "classnames"
import { CellChanges, CompositionSplit } from "./CompositionSplit"
import { useDispatch, useSelector } from "react-redux"
import { addManualInputThunk, deleteManualInputThunk } from "@/store/flowsheet/actions"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { IVariable } from "../types"
import { RunState, getFlowSimulationSelector, getStatus } from "@/store/flowsheet/flowsheet.slice"




interface CellChange {
  componentIndex: number
  val: number
  key: string 
}

interface EditCompositionSplitProps {
  data: any
  unit: NodeState
  splitterId: string
  readonly?: boolean
}

export function EditCompositionSplit(props: EditCompositionSplitProps) {
  const {data: simData, unit, splitterId, readonly = true} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const status = useSelector(getStatus);
  const [changes, setChanges] = useState<CellChanges>({})
  const dispatch = useDispatch()

  const saveChanges = async () => {
    if (!flowSimulation) {
      return;
    }
    const changed: IVariable[] = []
    const deleted: IVariable[] = []
    Object.values(changes).forEach(item => {
      if (item.val === undefined) {
        deleted.push({
          unitId: splitterId || unit.id,
          attribute: item.key,
        })
      } else {
        changed.push({
        unitId: splitterId || unit.id,
        attribute: item.key,
        value: item.val
      })
      }
    })
    
    if (changed.length > 0) {
      await dispatch(addManualInputThunk({
        data: {dvars: changed},
        params: {sId: flowSimulation.id}
      }))
    }

    if (deleted.length > 0) {
      await dispatch(deleteManualInputThunk({
        data: {dvars: deleted},
        params: {sId: flowSimulation.id}
      }))
    }
    setChanges({})
  }

  const onChanges = (change: CellChanges) => {
    setChanges({...changes, ...change})
  }

  return <EditModal title="Edit Split Ratio"
    width={800}
    trigger={status !== RunState.Stop && <EditOutlined />}
    onOk={saveChanges}
  >
      <CompositionSplit readonly={false} data={simData} unit={unit} onChange={onChanges} />
  </EditModal>
}